import React  from 'react';
import { withRouter } from "react-router";
import { ROUTE_LOGIN } from '../../../js/constants/route-names';
import { connect } from "react-redux";

import styled from 'styled-components';
import {Typography, Grid, Container, Box} from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
//import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded';
import { START_LOADING, STOP_LOADING, SET_USER, SNACK } from '../../../js/constants/action-types';
import { ALERT_ERROR, ALERT_SUCCESS } from '../../../js/constants/alert-types';

import request from '../../../js/utils/fetch';
import ButtonStyled from "../../ui/button/Button";
import logo from '../../../assets/images/logo-sinfin-digital.svg';
import FormBuilder from '../../ui/form/FormBuilder';
import colors from '../../../config/theme/colors';

// import LegoLogo from '../../../assets/images/logo_lego.svg';
// import SinfinLogo from '../../../assets/images/logo_sinfin.png';

import './Login.scss';
import { default as ForgotPasswordTemplate } from '../../../email/forgetPassword';

const inputsLogin = [
  {
    type: 'text',
    label: 'Adresse e-mail',
    helper: {
      text: '',
      link: false
    },
    required: true,
    stateName: 'email',
    disabled: false,
  }
]

const ContainerLogin = styled(Grid)`
  // top: 48%;
  // position: relative;
  // transform: translateY(-50%);
`
const ContainerCustom = styled(Container)`
  background: #fff;
  padding: 4rem !important;
  position: relative;
  left: auto;
  margin: auto;
  border: 0.5px solid ${colors.grey.lighter.hue700};
`
const ReturnLink = styled(Typography)`
    color: ${colors.blue.darker.hue300};
    cursor: pointer;
    &:hover{
        text-decoration: underline;
    }
`

const ButtonCustom = styled(ButtonStyled)`
  margin:auto;
  width: 100%;
  padding: 14px 32px;
`
const GridCustom = styled(Grid)`
	padding: 0 32px;
	@media screen and (max-width: 1280px){
		padding: 0 24px;
	}
`

const SpanColor = styled.span`
    color: ${colors.blue.darker.hue300};
    font-weight: bold;
`

class ForgetPassword extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            email: ''
        }
    }

    goTo = (route) => {
        this.props.history.push(route);
    };

    handleInputChange = (stateName, evt) => {
        const value = evt.target.value;

        this.setState({
            ...this.state,
            [stateName]: value
        });
    };

    componentDidMount() {
      document.addEventListener("keydown", this.handleKeyPress, false);
    }
  
    componentWillUnmount(){
      document.removeEventListener("keydown", this.handleKeyPress, false);
    }

    handleKeyPress = (event) => {
      if(event.key === 'Enter'){
        this.onSubmit()
      }
    }

    onSubmit = () => {
      if (!this.state.email || !/(.+)@(.+){2,}\.(.+){2,}/.test(this.state.email))
        return this.props.snack(ALERT_ERROR, 'Veuillez renseigner une adresse email valide');

      this.props.startLoading();


      // Clear to avoid old tokens to be used

      localStorage.removeItem('AUTH_USER');
      localStorage.removeItem('AUTH_TOKEN');
      localStorage.removeItem('AUTH_TOKEN_EXPIRY');

      request(`${process.env.REACT_APP_API}/public/forgot-password/request`, 'post', {
        username: this.state.email
      }).then((data) => {
        this.props.snack(ALERT_SUCCESS, 'Si votre adresse e-mail existe vous allez recevoir un email pour réinitialiser votre mot de passe');
        this.props.stopLoading();
      });
    };

    render() {
        return (
    
            <Grid container justifyContent={"center"} className={"login"}>
            {/* <AppBar
                position="fixed"
                color={"primary"}
                className={"appBar"}
            >
                <Toolbar className={"toolbar"}>
                    <img className={"logoDXP"} src={logo} height="25px" width="225px" alt="logo-DXP" />
                </Toolbar>
            </AppBar> */}
            <Grid container justifyContent="center" style={{marginBottom: 8}}>
              <img src={logo} alt="logo-dxp" style={{ maxWidth: '250px' }} />
            </Grid>
            <ContainerLogin item xs={8}>
                <ContainerCustom maxWidth={"sm"}>
                    <Grid container>
                        <Grid item xs={6}>
                            <Box onClick={this.props.history.goBack} style={{marginTop: -15}}>
                                <ReturnLink variant={'body2'}>&lt; Retour</ReturnLink>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid style={{marginTop: '2rem'}} container justifyContent="center">
                        <Box textAlign={'center'} style={{maxWidth: '100%'}}>
                            <Typography variant={'h3'}>Mot de passe oublié</Typography>
                            <Typography variant={'body1'} style={{marginTop: '0.5rem'}}>Pour <SpanColor>réinitialiser votre mot de passe,</SpanColor><br/> saisissez l'adresse e-mail que vous utilisez<br/> pour votre compte <SpanColor>Sinfin DXP.</SpanColor></Typography>
                        </Box>
                        <FormBuilder isLogin={true} optionsInputs={inputsLogin} stateCallback={this.handleInputChange} allState={this.state} backgroundColor={'white'} padding={'32px 32px 8px'} />
                        <GridCustom container>
                          <ButtonCustom text="Recevoir mon lien" className="button" onClick={this.onSubmit} />
                        </GridCustom>
                    </Grid>
                </ContainerCustom>
              {/* <Box mt={2} mb={4}>
                <Typography variant="body2">Vous ne connaissez pas l’URL de votre espace de travail ? <LinkText variant="body2">Trouver votre espace de travail</LinkText></Typography>
              </Box>
              <Box mb={4} textAlign={"center"}>
                <TypographyCustom variant="h3">Vous êtes déjà connecté(e) à cet espace de travail :</TypographyCustom>
              </Box>
              <GridCustom container justifyContent={"space-between"}>
                  <Grid item xs={6}>
                    <Box mr={2}>
                      <CardCustom>
                        <CardContentStyled>
                          <Grid container alignItems={"center"}>
                            <Grid item xs={4}>
                              <Box mr={2}>
                                <img src={LegoLogo} width={"100%"}/>
                              </Box>
                            </Grid>
                            <Grid item xs={8}>
                              <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                <WorkspaceName variant={"h4"}>LEGO®</WorkspaceName>
                                <ArrowForwardIosRoundedIcon fontSize="small"  />
                              </Grid>
                            </Grid>
                          </Grid>
                        </CardContentStyled>
                      </CardCustom>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box ml={2}>
                      <CardCustom>
                        <CardContentStyled>
                          <Grid container alignItems={"center"}>
                            <Grid item xs={4}>
                              <Box mr={2}>
                                <img src={SinfinLogo} width={"100%"}/>
                              </Box>  
                            </Grid>
                            <Grid item xs={8}>
                              <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                <WorkspaceName variant={"h4"}>Sinfin</WorkspaceName>
                                <ArrowForwardIosRoundedIcon fontSize="small"  />
                              </Grid>
                            </Grid>
                          </Grid>
                        </CardContentStyled>
                      </CardCustom>
                    </Box>
                  </Grid>
              </GridCustom> */}
            </ContainerLogin>
          </Grid>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    startLoading: () => dispatch({ type: START_LOADING }),
    stopLoading: () => dispatch({ type: STOP_LOADING }),
    setUser: (user) => dispatch({ type: SET_USER, payload: { user }}),
    snack: (type, message) => dispatch({ type: SNACK, payload: { type, message }})
  }
}

const mapStateToProps = state => {
  return {
    loading: state.loading
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForgetPassword));
